// Custom styles for React Select multiselect dropdowns
export const customStyles = {
  control: (provided, state) => ({
    ...provided,
    borderColor: state.isFocused ? '#80bdff' : '#ced4da',
    boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(13, 110, 253, 0.25)' : null,
    '&:hover': {
      borderColor: state.isFocused ? '#80bdff' : '#ced4da',
    },
    minHeight: '38px',
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '0 8px',
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#e9ecef',
    borderRadius: '4px',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    fontSize: '0.875rem',
    padding: '2px 6px',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: '#495057',
    ':hover': {
      backgroundColor: '#dee2e6',
      color: '#212529',
    },
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: '250px',
  }),
};
